import { Box } from "@mui/material";
import { motion } from "framer-motion";

const LoadingAnimation = () => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "200px",
        gap: "8px",
      }}
    >
      {[...Array(3)].map((_, index) => (
        <motion.span
          key={index}
          animate={{ y: [0, -10, 0] }}
          transition={{
            repeat: Infinity,
            duration: 0.6,
            ease: "easeInOut",
            delay: index * 0.2,
          }}
          style={{
            width: "10px",
            height: "10px",
            backgroundColor: "var(--primary-color)",
            borderRadius: "50%",
            display: "inline-block",
          }}
        />
      ))}
    </Box>
  );
};

export default LoadingAnimation;
